import Typography from "../../Typography";

interface IProps {
    value: string;
    suffix?: string | boolean;
}

const DefaultCell = ({ value, suffix }: IProps) => (
    <Typography variant="caption" fontWeight="medium" color="text">
        {value}
        {suffix && (
            <Typography variant="caption" fontWeight="medium" color="secondary">
                &nbsp;&nbsp;{suffix}
            </Typography>
        )}
    </Typography>

);

DefaultCell.defaultProps = {
    suffix: "",
};

export default DefaultCell;
